import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";

import { CardModule } from "primeng/card";
import { TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { IconComponent } from "@zaeper/angular-dashboard-view-lib";
import {
  userAuthenticationRestClientInjectionToken
} from "../../../../../../rest-clients/user/authentication/user-authentication-rest-client-injection-token";
import {
  IUserAuthenticationRestClient
} from "../../../../../../rest-clients/user/authentication/i-user-authentication-rest.client";
import { ILoginAttempt } from "../../../../../../rest-clients/user/authentication/responses/i-login-attempt";

@Component({
  selector: "app-login-attempts-tab",
  templateUrl: "./login-attempts-tab.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CardModule,
    TableModule,
    TagModule,
    IconComponent
]
})
export class LoginAttemptsTabComponent implements OnInit {
  public loginAttempts: ILoginAttempt[] = [];

  constructor(
    @Inject(userAuthenticationRestClientInjectionToken) private readonly _userRestClient: IUserAuthenticationRestClient,
    private readonly _changeDetectorRef: ChangeDetectorRef
  ) {
  }

  public ngOnInit(): void {
    this._userRestClient.getLoginAttempts()
      .then(( loginAttempts: ILoginAttempt[] ) => {
        this.loginAttempts = loginAttempts.sort(( a: ILoginAttempt, b: ILoginAttempt ) =>
          new Date( b.timestamp ).getTime() - new Date( a.timestamp ).getTime()
        );
        this._changeDetectorRef.markForCheck();
      });
  }

  public formatDate(timestamp: string): string {
    const date: Date = new Date(timestamp);
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  public formatTime(timestamp: string): string {
    const date: Date = new Date(timestamp);
    return date.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  public parseBrowser(userAgent: string): string {
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
      return 'Chrome';
    } else if (userAgent.includes('Firefox')) {
      return 'Firefox';
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      return 'Safari';
    } else if (userAgent.includes('Edg')) {
      return 'Edge';
    }
    return 'Unbekannt';
  }

  public parseOS(userAgent: string): string {
    if (userAgent.includes('Windows')) {
      return 'Windows';
    } else if (userAgent.includes('Macintosh')) {
      return 'macOS';
    } else if (userAgent.includes('Linux') && !userAgent.includes('Android')) {
      return 'Linux';
    } else if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
      return 'iOS';
    } else if (userAgent.includes('Android')) {
      return 'Android';
    }
    return 'Unbekannt';
  }
}
